/* @flow */
import React from 'react';

import Styled from './styled';
import Icon from '../Icon';
import { Dropdown } from 'semantic-ui-react';

export type Item = {
  actions?: any,
  disabled?: boolean,
  iconName: string,
  items?: Item[],
  label?: any,
  loading?: boolean,
  menuExpandDirection?: 'left' | 'right',
  onClick?: () => mixed,
  size?: 'default' | 'inherit' | 'large' | 'small',
  tooltip?: string,
};

type Props = Item;

class ActionButton extends React.PureComponent<Props, void> {
  state = {
    showMenu: false,
  };

  render() {
    const {
      disabled = false,
      iconName,
      items = [],
      label,
      loading = false,
      menuExpandDirection = 'left',
      onClick = () => null,
      size,
      tooltip,
    } = this.props;
    const renderMenu = !disabled && !loading && items.length > 0;

    return (
      <Styled.Container disabled={disabled}>
        {!renderMenu && (
          <Styled.MainItem onClick={onClick}>
            <Icon
              disabled={disabled}
              loading={loading}
              name={iconName}
              size={size}
              tooltip={tooltip}
            />
            {label && <div>{label}</div>}
          </Styled.MainItem>
        )}
        {renderMenu && (
          <Dropdown
            disabled={disabled}
            icon={null}
            text={
              <div>
                <Styled.MainItem>
                  <Icon
                    disabled={disabled}
                    loading={loading}
                    name={iconName}
                    size={size}
                    tooltip={tooltip}
                  />
                  {label && <div>{label}</div>}
                </Styled.MainItem>
              </div>
            }
            direction={menuExpandDirection}
          >
            <Dropdown.Menu>
              {items.map(({ label, onClick, iconName, actions, children }, index) => {
                return (
                  <>
                    <Styled.Item key={index} onClick={onClick}>
                      <Icon
                        disabled={disabled}
                        loading={loading}
                        name={iconName}
                        size={size}
                        tooltip={tooltip}
                      />
                      <Styled.ItemLabel>{label}</Styled.ItemLabel>
                      <Styled.ItemActions>{actions}</Styled.ItemActions>
                    </Styled.Item>
                    {children && (
                      <div
                        className={'scrollable-dropdown-menu'}
                        style={{ maxHeight: '296px', overflowY: 'auto' }}
                      >
                        {children.map((child, cIdx) => {
                          return (
                            <Styled.Item key={`${index}-${cIdx}`} onClick={child.onClick}>
                              <Icon
                                disabled={disabled}
                                loading={loading}
                                name={child.iconName}
                                size={size}
                                tooltip={child.tooltip}
                              />
                              <Styled.ItemLabel>{child.label}</Styled.ItemLabel>
                              <Styled.ItemActions>{child.actions}</Styled.ItemActions>
                            </Styled.Item>
                          );
                        })}
                      </div>
                    )}
                  </>
                );
              })}
            </Dropdown.Menu>
          </Dropdown>
        )}
      </Styled.Container>
    );
  }
}

export default ActionButton;
